import { IconProps } from './index';

const Eye: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M2.07373 3.46154L0.249643 1.63804L1.07506 0.812622L12.6245 12.3626L11.7991 13.1875L9.86823 11.2566C8.84227 11.9074 7.65199 12.252 6.43706 12.25C3.29173 12.25 0.674893 9.98671 0.125977 7.00004C0.376827 5.64129 1.06026 4.40006 2.07431 3.46154H2.07373ZM8.04531 9.43371L7.19131 8.57971C6.86467 8.73599 6.4976 8.7871 6.14069 8.726C5.78378 8.66489 5.45461 8.49458 5.19857 8.23853C4.94252 7.98249 4.77221 7.65332 4.7111 7.29641C4.65 6.9395 4.70111 6.57243 4.85739 6.24579L4.00339 5.39179C3.63223 5.95266 3.4663 6.62457 3.53371 7.29374C3.60112 7.96292 3.89772 8.58823 4.3733 9.0638C4.84887 9.53938 5.47418 9.83598 6.14336 9.90339C6.81253 9.9708 7.48444 9.80487 8.04531 9.43371ZM4.08856 2.19337C4.81598 1.90754 5.60873 1.75004 6.43706 1.75004C9.58239 1.75004 12.1992 4.01337 12.7481 7.00004C12.5694 7.9717 12.1676 8.88863 11.5745 9.67871L9.32281 7.42704C9.3897 6.97648 9.35012 6.51652 9.20727 6.084C9.06441 5.65149 8.82224 5.25845 8.50015 4.93636C8.17807 4.61428 7.78503 4.37211 7.35251 4.22925C6.92 4.08639 6.46004 4.04682 6.00948 4.11371L4.08856 2.19396V2.19337Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Eye;
